import React from 'react';
import './MusicList.css';
import {musicList} from './music';

function MusicList() {
  return (
    <div className="music-list">
      {musicList.map((music) => (
        <div className="content">
          <a href={music.redirectedUrl} target="_blank" rel="noreferrer">
            <div className="content-overlay"></div>
            <img className="content-image" src={music.imgSrc} alt={music.title} />
            <div className="content-details fadeIn-bottom">
              <h3 className="content-title">{music.title}</h3>
              <p className="content-text">{music.releaseDate}</p>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
}

export default MusicList;
